export const iconFontAwesomeFoodBeverageBowlFood = (
	<i className="fa-solid fa-bowl-food"></i>
);
